import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {useState} from "react";
import SpotifyLogin from "./components/SpotifyLogin";
import logo from "./poop.png";
import Shitster from "./components/Shitster";
import Container from "react-bootstrap/Container";

function App() {
  // 'loginDone' state to avoid flickering divs..
  const [loginDone, setLoginDone] = useState(false)
  const [token, setToken] = useState(null)

  return (
    <Container className="App">
      {token ?
        // Shitster content after login
        <Shitster token={token}/> :
        // Poop emoji before login
        <div className={'PoopPic'}><img src={logo} alt={'Shitster logo'} /></div>}
      <SpotifyLogin token={token} setToken={setToken} loginDone={loginDone} setLoginDone={setLoginDone}/>
    </Container>
  );
}

export default App;
